export const TITLE_NODE_NAME = 'title';

export const TITLE_PLACEHOLDER = 'Untitled';
